import { useState, useEffect } from "react";
import { createTheme } from "@mui/material";
import { buildApiUrl } from "../utils/urlHelpers";

function useWordPressTheme() {
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    // Check if wpData is available
    if (!window.wpData || !window.wpData.restUrl) {
      console.warn("WordPress data not available, using default theme");
      setTheme(createTheme());
      return;
    }

    // Try to fetch theme settings from WordPress
    const fetchThemeSettings = async () => {
      try {
        // First try the custom endpoint
        const customApiUrl = buildApiUrl('react-theme/v1/settings');
        
        const customResponse = await fetch(customApiUrl, {
          headers: {
            "X-WP-Nonce": window.wpData?.nonce || "",
            "Content-Type": "application/json",
          },
          credentials: "same-origin",
        });

        if (customResponse.ok) {
          const data = await customResponse.json();
          setTheme(
            createTheme({
              palette: {
                primary: {
                  main: data.primaryColor || "#0e3158",
                  },
                  secondary: {
                  main: data.secondaryColor || "#f0b94d",
                },
              },
            })
          );
          return;
        }

        // If custom endpoint fails, just use default theme
        console.warn("Custom theme endpoint not available, using default theme");
        setTheme(createTheme({
          palette: {
            primary: {
              main: "#0e3158",
            },
            secondary: {
              main: "#f0b94d",
            },
          },
        }));
      } catch (error) {
        console.error("Error fetching WordPress theme settings:", error);
        // Use default theme on error
        setTheme(createTheme());
      }
    };

    fetchThemeSettings();
  }, []);

  return theme || createTheme(); // Return default theme while loading
}

export default useWordPressTheme;
